<section id="cabecalho" [style.background-image]="'url(' + (data.IMAGEM) + ')'">
    <div class="container content">
        <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-6">
                <h6 class="text-info mb-4">{{ data.TELA }}</h6>
                
                <h3 class="mb-4">{{ data.TITULO }}</h3>
                <p class="mb-4">{{ data.DESCRICAO }}</p>
            </div>
        </div>
    </div>
</section>